import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import RequiredLabel from './RequiredLabel';
import { CONTROL_CLASSES } from './FormField';

const CNICField = ({ name = 'cnic', required = true, 'data-testid': dataTestId }) => {
  const { control, formState: { errors } } = useFormContext();
  const error = errors[name];

  const formatCNIC = (value) => {
    let cleanValue = value.replace(/[^0-9]/g, "");
    if (cleanValue.length > 13) cleanValue = cleanValue.slice(0, 13);
    
    let formatted = cleanValue;
    if (cleanValue.length > 5) formatted = cleanValue.slice(0, 5) + '-' + cleanValue.slice(5);
    if (cleanValue.length > 12) formatted = formatted.slice(0, 13) + '-' + formatted.slice(13);
    
    return formatted;
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {required ? <RequiredLabel required={required}>CNIC</RequiredLabel> : 'CNIC'}
        <span className='text-xs text-gray-400 ml-1'>(Format: XXXXX-XXXXXXX-X)</span>
      </label>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? 'CNIC is required' : false,
          pattern: {
            value: /^[0-9]{5}-[0-9]{7}-[0-9]$/,
            message: 'CNIC must be in format XXXXX-XXXXXXX-X'
          }
        }}
        render={({ field }) => (
          <input
            type="text"
            placeholder="XXXXX-XXXXXXX-X"
            className={CONTROL_CLASSES}
            {...(dataTestId ? { 'data-testid': dataTestId } : {})}
            value={field.value || ''}
            onChange={e => {
              const formatted = formatCNIC(e.target.value);
              field.onChange(formatted);
            }}
          />
        )}
      />
      {error && <p className="text-red-500 text-xs mt-2">{error.message}</p>}
    </div>
  );
};

export default CNICField; 